import m from "./../../../dist/es2015/locales/id_ID.js";
export const am5locales_id_ID = m;